import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
    selector: 'app-access-request-dialog',
    templateUrl: './access-request-dialog.component.html',
    styleUrl: './access-request-dialog.component.scss',
    standalone: false
})
export class AccessRequestDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AccessRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, type: string }
  ) {}
  onClose(): void {
    this.dialogRef.close();
  }
}
